import get from 'lodash/get';
import { RomAppState, RomEditorState } from 'routes/rom/interfaces';

export const getRomRom = (state: RomAppState) => get(state, 'rom', {} as RomEditorState);
export const getRomId = (state: RomAppState) => get(getRomRom(state), 'romId');

export const getMetaData = (state) => get(getRomRom(state), 'metaData', {});
export const getMetaDataList = (state, key: string) => get(getMetaData(state), key, undefined);
export const hasMetaDataList = (state, key: string) => !!getMetaDataList(state, key);
export const hasMetaDataListItems = (state, key: string) => !!getMetaDataList(state, key).length;
export const getMetaDataConfigKeys = (state, key: string) => getMetaDataList(state, key).map(meta => meta.configKey);

export const filterOptions = (state, options, key) => {
    const metaDataList = getMetaDataList(state, key);
    if (metaDataList) {
        return options.filter(option => !metaDataList.some(meta => meta.configKey === option.configKey) && option);
    } else {
        return options;
    } 
};
